import React, { useState } from "react";
import { useFieldArray, useFormContext } from "react-hook-form";
import { GridLegacy, IconButton, List, ListItem, TextField, Typography } from "@mui/material";
import TranslationWrapper, { getTranslation } from "../../../components/TranslationWrapper/TranslationWrapper";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import AsynchronousAutocomplete from "../../../components/Autocomplete/AsynchronousAutocomplete";
import Tooltip from "@mui/material/Tooltip";
import Button from "../../../components/CustomButtons/Button";
import { Link } from "react-router";
import Edit from "@mui/icons-material/Edit";
import { Delete } from "@mui/icons-material";
import FormElement from "../../../components/JamezzTable/FormElement";
import ProductsInCategories from "../../../../../Domains/OptionGroups/Categories/ProductsInCategories";

export default function ChildProductGroups() {
  const { control } = useFormContext();
  const { fields, append, prepend, remove, swap, move, insert } = useFieldArray({
    control,
    name: "child_product_groups",
    keyName: "key",
  });

  return (
    <>
      <Card>
        <CardBody style={{ padding: 16 }}>
          <GridLegacy container spacing={1}>
            <GridLegacy item xs={12}>
              <List>
                <ListItem>
                  <GridLegacy container>
                    <GridLegacy item xs={4}>
                      <TranslationWrapper tKey={"Product group name"} />
                    </GridLegacy>
                    <GridLegacy item xs={2}>
                      <TranslationWrapper tKey={"Product group default sort key"} />
                    </GridLegacy>
                    <GridLegacy item xs={2}>
                      <TranslationWrapper tKey={"Sort key"} />
                    </GridLegacy>
                    <GridLegacy item xs={4} />
                  </GridLegacy>
                </ListItem>

                {fields.map((field, index) => {
                  return (
                    <ListItem>
                      <GridLegacy container>
                        <GridLegacy item xs={4}>
                          <Typography style={{ margin: "0 16px" }}>{field.naam}</Typography>
                        </GridLegacy>
                        <GridLegacy item xs={2}>
                          <Typography style={{ margin: "0 16px" }}>{field.sortkey}</Typography>
                        </GridLegacy>
                        <GridLegacy item xs={2}>
                          <Typography style={{ margin: "0 16px" }}>
                            {field.pivot ? (
                              <FormElement
                                endPoint={"core/optionGroupProductGroups"}
                                name={"sort_key"}
                                row={field.pivot}
                              >
                                <TextField
                                  placeholder={field.pivot?.sort_key ?? field.sortkey}
                                  size={"small"}
                                  variant={"standard"}
                                />
                              </FormElement>
                            ) : null}
                          </Typography>
                        </GridLegacy>
                        <GridLegacy item xs={4}>
                          <IconButton
                            onClick={() => {
                              remove(index);
                            }}
                          >
                            <Delete />
                          </IconButton>

                          <Link to={`/manager/kaarten/${field.id}/edit`}>
                            <Tooltip
                              classes={{}}
                              placement={"bottom"}
                              title={
                                <TranslationWrapper
                                  tDefault={"View Product Group"}
                                  tKey={"global.jamezzTable.viewProductGroup"}
                                />
                              }
                            >
                              <Button color={"success"} simple>
                                <Edit />
                              </Button>
                            </Tooltip>
                          </Link>
                        </GridLegacy>
                      </GridLegacy>
                    </ListItem>
                  );
                })}
              </List>

              {/*</div>*/}
              {/*)}*/}
              {/*</Draggable>*/}
              {/*))}*/}
              {/*{provided.placeholder}*/}
              {/*</Box>*/}
              {/*)}*/}
              {/*</Droppable>*/}
              {/*</DragDropContext>*/}

              {/*<AsyncRelationField*/}
              {/*  // fieldProps={fieldProps}*/}
              {/*  key={"child_products" + menukaartVestigingId}*/}
              {/*  name={"child_products"}*/}
              {/*  tKey={"producten.form.childProducts"}*/}
              {/*  tDefault={"Option Items"}*/}
              {/*  async={{*/}
              {/*    url:*/}
              {/*      "core/producten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +*/}
              {/*      menukaartVestigingId,*/}
              {/*    searchField: "naam",*/}
              {/*  }}*/}
              {/*  multiple={true}*/}
              {/*/>*/}
            </GridLegacy>
          </GridLegacy>

          <AddChildProductGroup append={append} />
        </CardBody>
      </Card>
      <ProductsInCategories categories={fields} />
    </>
  );
}

function AddChildProductGroup({ append }) {
  const { register, vestigingId, menukaartVestigingId, reloadDataFromServer } = useFormContext();
  const [productGroup, setProductGroup] = useState(null);
  return (
    <>
      <AsynchronousAutocomplete
        async={{
          url: `core/kaarten/search?fields=id as value,id,naam as label,vestiging_id,naam,sortkey&sort_field=naam&sort_dir=asc&vestiging_id=${menukaartVestigingId}`,
          searchField: "naam",
          perPage: 20,
          // extraFilters: { vestiging_id: { name: "vestiging_id", value: "vestiging_id" } },
        }}
        key={menukaartVestigingId}
        onChange={(e, option) => {
          setProductGroup(option);
        }}
        placeholder={getTranslation("Find product group")}
        value={productGroup}
      />
      <Button
        disabled={!productGroup}
        onClick={() => {
          setProductGroup(null);
          append(productGroup);
        }}
      >
        <TranslationWrapper tKey={"Add product group"} />
      </Button>
    </>
  );
}
